import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth';

export default withWidth;
export { isWidthUp, isWidthDown };